import SelectInput from '../SelectInput/SelectInput';
import { ButtonContinue } from '../Button/ButtonContinue';
import {
  Modification,
  SelectOpt,
  VehicleModificationError
} from '../CommonTypes';

interface VehicleModificationsProps {
  modifications: Modification[];
  modificationTypes: SelectOpt[];
  forDisabilityOptions: SelectOpt[];
  errorMessages: VehicleModificationError[];
  onUpdateModifications: (modifications: Modification[]) => void;
}

const VehicleModifications = ({
  modifications,
  modificationTypes,
  forDisabilityOptions,
  errorMessages,
  onUpdateModifications
}: VehicleModificationsProps) => {
  const onClickAddAnotherModification = (): void => {
    const newModifications = [
      ...modifications,
      { modificationType: '', forDisability: '' } as Modification
    ];
    onUpdateModifications(newModifications);
  };

  const onClickRemoveModification = (index: number): void =>
    onUpdateModifications(modifications.filter((c, i) => index !== i));

  const onChangeModificationType = (value: string, index: number) => {
    const updatedModifications = modifications.map((m, i) =>
      i === index ? { ...m, modificationType: value } : { ...m }
    );
    onUpdateModifications(updatedModifications);
  };

  const onChangeForDisability = (value: string, index: number) => {
    const updatedModifications = modifications.map((m, i) =>
      i === index ? { ...m, forDisability: value } : { ...m }
    );
    onUpdateModifications(updatedModifications);
  };

  return (
    <div className='add-new-modification'>
      {modifications.map((modification, index) => (
        <div key={`modification-${index}`}>
          <div className='flex-row'>
            <div className='inline-control'>
              <div className='control-label'>Type of modification</div>
              <div className='control'>
                <SelectInput
                  name={`type-of-modification-${index}`}
                  className='input-text w250'
                  value={modification.modificationType}
                  onChange={(value: string) => {
                    onChangeModificationType(value, index);
                  }}
                  options={modificationTypes}
                  defaultText='Select...'
                  forceDefault
                  addDefaultOption
                  loadingText='Loading...'
                  error={errorMessages?.at(index)?.modificationType ?? ''}
                />
              </div>
            </div>
            <div className='inline-control'>
              <div className='control-label'>For disability?</div>
              <div className='control'>
                <SelectInput
                  name={`for-disability-${index}`}
                  className='input-text w250'
                  value={modification.forDisability}
                  onChange={(value: string) => {
                    onChangeForDisability(value, index);
                  }}
                  options={forDisabilityOptions}
                  defaultText='Select...'
                  forceDefault
                  addDefaultOption
                  loadingText='Loading...'
                  error={errorMessages?.at(index)?.forDisability ?? ''}
                />
              </div>
            </div>
            {index > 0 && (
              <div className='inline-control remove-button-wrapper'>
                <ButtonContinue
                  name={`remove-modification-line-${index}`}
                  text={'Remove'}
                  onClick={() => onClickRemoveModification(index)}
                  additionalClassNames='btn-cancel'
                />
              </div>
            )}
          </div>
          {modifications.length - 1 === index && modifications.length < 9 && (
            <div>
              <ButtonContinue
                name={`add-another-modification-${index}`}
                text={'Add another modification'}
                onClick={onClickAddAnotherModification}
                additionalClassNames='btn-ok'
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VehicleModifications;
